module.exports = __webpack_public_path__ + "static/media/logo-chr.64a137a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-chr.png
// module id = 177
// module chunks = 0